import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonToggleComponent } from './button-toggle.component';

@NgModule({
	declarations: [ButtonToggleComponent],
	imports: [CommonModule, FormsModule],
	exports: [ButtonToggleComponent]
})
export class WmButtonToggleModule {}
